import { ApiParameter, del, get, patch, post } from "@insite/client-framework/Services/ApiService";

const msgUrl = "api/v2/orderapproval/GetMessages";
const cartsUrl = "/api/v1/carts";
const reviewOrderUrl = "api/v2/orderapproval/ReviewOrder";
const cartAuditUrl = "/api/v2/WebCartAudit/OrderNumber";
const cancelOrderApprovalUrl = "api/v2/orderapproval/CancelOrder";
export interface loadOrderApprovalNotesResponse {
    [key: string]: string;
}
export interface loadOrderApprovalNotesParams extends ApiParameter {
    orderNumber: string;
    onError?: (message: string) => void;
    onSuccess?: (result: loadOrderApprovalNotesResponse | WebAuditResponseModel[]) => void;
}

export interface ReviewOrderApprovalParams extends ApiParameter {
    orderNumber: string;
    fromStatus: string;
    notes: string;
    approverUserName: string;
    cancelOrder: boolean;
    onError?: (message: string) => void;
    onSuccess?: (result: any) => void;
}

export interface UpdateOrderApprovalCartCartToCancel extends ApiParameter {
    properties: {
        Notes?: string;
        ApproverUserName?: string;
    };
}

export interface WebAuditResponseModel {
    id: string;
    customProperties: any[];
    orderNumber: string;
    cartName: string;
    orderTotal: number;
    dateTime: string;
    name: string;
    fromStatus: string;
    toStatus: string;
    approvalLevel: number;
    notes: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
    cartTotalDisplay:string;

}

export const getOrderApprovalNotesFn = async (parameter: loadOrderApprovalNotesParams) => {
    const response = await get<loadOrderApprovalNotesResponse>(`${msgUrl}/${parameter.orderNumber}`);
    return response;
};
export const getCartAuditFn = async (parameter: loadOrderApprovalNotesParams) => {
    const response = await get<WebAuditResponseModel[]>(
        `${cartAuditUrl}/?OrderNumber=${parameter.orderNumber}&ts=${Date.now()}`,
    );
    return response;
};

export function postReviewApprovalFn(parameter: ReviewOrderApprovalParams) {
    const parameterModel = {
        orderNumber: parameter.orderNumber,
        fromStatus: parameter.fromStatus,
        notes: parameter.notes,
        approverUserName: parameter.approverUserName,
    };

    return post<any, any>(reviewOrderUrl, parameterModel);
}

export function cancelOrderApprovalFn(parameter: ReviewOrderApprovalParams) {
    const parameterModel = {
        orderNumber: parameter.orderNumber,
        fromStatus: parameter.fromStatus,
        notes: parameter.notes,
        approverUserName: parameter.approverUserName,
    };

    return post<any, any>(cancelOrderApprovalUrl, parameterModel);
}

export async function cancelOrderApproval(parameter: UpdateOrderApprovalCartCartToCancel) {
    const patchModel: UpdateOrderApprovalCartCartToCancel = {
        properties: {
            Notes: parameter.properties.Notes,
            ApproverUserName: parameter.properties.ApproverUserName,
        },
    };

    const cartModel = await del(`${cartsUrl}/${parameter.properties.ApproverUserName}&${parameter.properties.Notes}`);

    return cartModel;
}
